// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  transferHistoryRequest: ['filter'],
  transferHistorySuccess: ['data'],
  transferHistoryFailure: ['err'],

  transferHistoryMatchesRequest: null,
  transferHistoryMatchesSuccess: ['data'],
  transferHistoryMatchesFailure: ['err'],

  transferHistoryUpdateRequest: ['data'],
  transferHistoryUpdateSuccess: ['data'],
  transferHistoryUpdateFailure: ['err'],

  transferHistoryListDownloadRequest: ['filter'],
  transferHistoryListDownloadSuccess: null,
  transferHistoryListDownloadFailure: ['err'],
})

export const TransferHistoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  err: null,
  data_matches: null,
  processing: false,
  success: null,
})

/* ------------- Reducers ------------- */
export const request = (state: Object) => state.merge({ fetching: true, success: null})

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const successMatches = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_matches: data,
    err: null
  })

export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null})

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.TRANSFER_HISTORY_SUCCESS]: success,
  [Types.TRANSFER_HISTORY_REQUEST]: request,
  [Types.TRANSFER_HISTORY_FAILURE]: failure,

  [Types.TRANSFER_HISTORY_MATCHES_SUCCESS]: successMatches,
  [Types.TRANSFER_HISTORY_MATCHES_REQUEST]: request,
  [Types.TRANSFER_HISTORY_MATCHES_FAILURE]: failure,

  [Types.TRANSFER_HISTORY_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.TRANSFER_HISTORY_UPDATE_REQUEST]: manipulateRequest,
  [Types.TRANSFER_HISTORY_UPDATE_FAILURE]: manipulateFailure,

  [Types.TRANSFER_HISTORY_LIST_DOWNLOAD_SUCCESS]: manipulateSuccess,
  [Types.TRANSFER_HISTORY_LIST_DOWNLOAD_REQUEST]: manipulateRequest,
  [Types.TRANSFER_HISTORY_LIST_DOWNLOAD_FAILURE]: manipulateFailure,
})



// WEBPACK FOOTER //
// ./src/Redux/TransferHistoryRedux.js